import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';
import { TemplateFormComponent } from '../template-form/template-form.component';
import { MatButton } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-edit-template-dialog',
    templateUrl: './edit-template-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, ReactiveFormsModule, TemplateFormComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class EditTemplateDialogComponent {
  @ViewChild(TemplateFormComponent) formComponent: TemplateFormComponent;

  constructor(
    private templateService: WorkshopJobTemplateService,
    private dialogRef: MatDialogRef<EditTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  save() {
    this.templateService
      .update(this.data.id, {
        ...this.formComponent.form.value,
        labour_cost: this.formComponent.form.value.labour_cost * 100
      })
      .subscribe(() => this.dialogRef.close({ updateList: true }));
  }
}
